<template>
    <div>
        <div class="btn-open-sidebar ipt-select">
            <i class="ico local jsSearchLocalization" v-on:click="getCurrentPosition"></i>
            <div v-if="searches.length > 0" class="form-data wrapper-text ipt" v-on:click="openSideBar">
                <span v-for="(result, i) in searches" v-if="i < 2" class="wrapper-result">
                     <span class="result-text" :class="{'result-text-small' : searches.length > 1}">
                         {{ result.name }}
                        <span class="result-code" v-if="[3, 4, 5].includes(result.location_type)">({{ result.zip }})</span>
                        <span class="result-code" v-else-if="result.location_type == '2'">({{ result.reference }})</span>
                     </span>
                     <span class="delete-result-loc-mobile" v-on:click.stop="removeResult(i)">×</span>
                </span>
                <span v-if="searches.length > 2" class="numberCircle">
                  <span class="badge badge-notify">+{{ searches.length - 2 }}</span>
                </span>
            </div>
            <div v-if="searches.length == 0" v-on:click="openSideBar" v-show="canChooseCity" class="wrapper-text ipt">
                <span class="result-text">Localisation</span>
            </div>
            <span class="iptLocalizationLabel ipt" v-model="iptLocalizationLabel" v-if="!canChooseCity" v-html="msgNoLocalization" v-on:click="allowCities"></span>
            <input type="hidden" name="locations[]" :value="searchesIds" class="form-data" data-filter="20">
        </div>

        <div class="header-sidebar-localization" slot="header" v-if="sideBar == true">
            <div class="header-sidebar-localization-child">
                <div class="title-sidebar">
                <span class="back-header" v-on:click="sideBar = !sideBar">
                    <i class="ico arr_left"></i>
                    <span class="title">Où cherchez-vous ?</span>
                </span>
                </div>
                <div class="container-results">
                    <div class="container-results-child">
                        <div class="autocomplete-localization">
                            <input type="text" placeholder="Localisation"
                                   v-model="search"
                                   v-on:click="showLocalizationContainer"
                                   @input="debouncedOnChange"
                                   @keydown.down="onArrowDown"
                                   @keydown.up="onArrowUp"
                                   @keydown.enter="onEnter"
                                   ref="inputLocalization"
                                   class="ipt ipt-mobile">
                            <div class="container-autocomplete" v-if="isOpen && search.length > 0">
                                <ul class="autocomplete-results" id="autocomplete-results">
                                    <li class="loading" v-if="isLoading">
                                        Chargement des résultats...
                                    </li>
                                    <li v-if="results.length == 0">
                                        Aucun résultat trouvé
                                    </li>
                                    <li class="autocomplete-result"
                                        v-else
                                        v-for="(result, i) in results"
                                        :key="i"
                                        :class="{ 'is-active': i === arrowCounter }"
                                        @click="setResult(result)">
                                        <div>
                                            <span class="result-name">{{ result.name }}</span>
                                            <span class="result-code" v-if="[3, 4, 5].includes(result.location_type)">({{ result.zip }})</span>
                                            <span class="result-code" v-else-if="result.location_type == '2'">({{ result.reference }})</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="containerLocalization containerLocalizationMobile" v-if="search.length === 0 && searches.length > 0">
                            <div class="form-localization">
                                <div v-for="(result, i) in searches" class="form-result-loc">
                                    <span class="result-text">
                                         {{ result.name }}
                                        <span class="result-code" v-if="[3, 4, 5].includes(result.location_type)">({{ result.zip }})</span>
                                        <span class="result-code" v-else-if="result.location_type == '2'">({{ result.reference }})</span>
                                     </span>
                                    <span class="delete-result-loc" v-on:click="removeResult(i)">×</span>
                                </div>
                            </div>
                            <div class="reset-all-localizations">
                                <span v-on:click="resetAll">Effacer</span>
                            </div>
                        </div>
                        <div class="footer-sidebar-localization" v-on:click="openSideBar">
                            <span class="validate-localization">Valider les localisations</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bindFilters from './../../../../../public/frontend/js/common/listenExport';
    import {initLocalization} from './mixins/initLocalization';
    import _debounce from 'lodash/debounce';

    export default {
        name: 'LocalizationMobile',
        data() {
            return {
                sideBar: false,
                cities: window.CITIES,
                showLocalization : false,
                isOpen: false,
                results: [],
                search: '',
                searches: [],
                isLoading: false,
                arrowCounter: 0,
                searchesIds: [],
                iptLocalizationLabel: '',
                canChooseCity: true,
                searchNoLocalization: '',
                msgNoLocalization: '',
            }
        },
        mixins: [initLocalization],
        props: ['filterData', 'hash', 'startSearch'],
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        created() {
            this.parseUrl();
        },
        beforeUpdate() {
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOutside)
        },
        computed: {
            debouncedOnChange () {
                return _debounce(this.autoComplete, 300);
            }
        },
        methods: {
            openSideBar: function() {
              if(this.sideBar == true)
              {
                  this.sideBar = false;
                  this.search = '';
                  $('.agences-info').removeClass("agences-info-2");
              } else {
                  this.sideBar = true;
                  Vue.nextTick(() => {
                      this.focusInput();
                  });
                  $('.agences-info').addClass("agences-info-2");
              }
            },
            focusInput: function() {
                this.$refs.inputLocalization.focus();
            },
            showLocalizationContainer: function() {
//                console.log(this.isMobile());
                if(!this.showLocalization)
                    this.showLocalization = true;

                this.$refs.inputLocalization.focus();
            },
            autoComplete(){
                if(this.search.length == 0) {
                    if(!this.showLocalization)
                        this.showLocalization = true;
                }
                else if(this.search.length > 0){
                    if(this.showLocalization == true) {
                        this.showLocalization = false;
                    }

                    if(this.isOpen == false) {
                        this.isOpen = true;
                    }

                    axios.get('/biens/search-localization',{params: {q: this.search, context: this.searches}}).then(response => {
                        this.results = response.data.cities;
                    });
                }
            },
            hideAll(evt) {
//                this.showLocalization = false;
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    if(this.isOpen == true)
                        this.isOpen = false;
                    this.arrowCounter = -1;
                }
            },
            setResult(result) {
                this.isOpen = false;
                this.search = '';
                this.showLocalization = true;
                this.searches.push(result);

                if(this.$refs.inputLocalization !== undefined)
                    this.$refs.inputLocalization.focus();

                this.getIdsFromSearch();
                if(this.startSearch == undefined || this.startSearch === 'true')
                {
                    bindFilters.updateFilters(20, this.searchesIds);
                }
            },
            removeResult(index) {
                this.searches.splice(index, 1);
                this.getIdsFromSearch();

                if(this.startSearch == undefined || this.startSearch === 'true')
                {
                    bindFilters.updateFilters(20, this.searchesIds);
                }
            },
            getIdsFromSearch() {
                this.searchesIds = [];
                for (var i = 0; i < this.searches.length; i++) {
                    if(this.searchesIds.indexOf(this.searches[i].slug) == -1) {
                        this.searchesIds.push(this.searches[i].slug);
                    }
                }

            },
            onArrowDown(evt) {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter -1;
                }
            },
            onEnter(event) {
                event.preventDefault();
                // this.search = this.results[this.arrowCounter];
                // this.isOpen = false;
                this.setResult(this.results[this.arrowCounter]);

                this.arrowCounter = -1;
            },
            resetAll() {
                this.isOpen = false;
                this.showLocalization = false;
                this.results = [];
                this.search = '';
                this.searches = [];
                this.searchesIds = [];
                bindFilters.updateFilters(this.searchesIds);
            },
            initSearch(hash) {

            },
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },
            removeSearchCities: function(text) {
                this.canChooseCity = false;
                this.msgNoLocalization = text + '<i class="fa fa-remove remove-localization"></i>';
                this.isOpen = false;
                this.showLocalization = false;
                this.results = [];
                this.search = '';
                this.searches = [];
                this.searchesIds = [];
            },
        }
    }
</script>